// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvaPaisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for salvaPais() /localidades/salvaPais
 *
 * Proxy to locations-service (Go microservice).
 * Returns the saved country record.
 */
import type { Localidades_BuscaestadosRow } from './Localidades_BuscaestadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_SalvaPaisResponseDados {
id?: number
name?: string
code?: string
states?: Localidades_BuscaestadosRow[]
}

export type Localidades_SalvaPaisResponse = ApiResponse<Localidades_SalvaPaisResponseDados>;

registerResponseContract('Localidades_SalvaPaisResponse', {
  id:     { type: 'number',  required: false },
  name:   { type: 'string',  required: false },
  code:   { type: 'string',  required: false },
  states: {
    type: 'array',
    required: false,
    items: {
      ID:        { type: 'number',  required: false },
      Name:      { type: 'string',  required: false },
      UF:        { type: 'string',  required: false },
      CountryID: { type: 'number',  required: false },
      Cities: {
        type: 'array',
        required: false,
        items: {
          ID:      { type: 'number',  required: false },
          Name:    { type: 'string',  required: false },
          StateID: { type: 'number',  required: false },
        },
      },
    },
  },
})
